import React from 'react';

import { SkeletonLoader } from 'common/react/components/SkeletonLoader';

/**
 * Displays a loading state for the Ins/Outs section when a single team is requested.
 *
 * @returns The Ins/Outs single team skeleton loader.
 */
export const InsOutsSingleSkeleton = () => (
    <>
        <div className="u-hide-until-tablet">
            <div className="team-lineups-condensed-embeddable--skeleton team-lineups-condensed-embeddable__ins-and-outs">
                <div className="team-lineups-condensed-embeddable__ins-and-outs-single">
                    <div className="team-lineups-condensed-embeddable__ins-and-outs-single-label">
                        <div className="team-lineups-ins-and-outs__title-wrapper">
                            <SkeletonLoader width={56} height={24} />
                        </div>
                    </div>
                    <div className="team-lineups-condensed-embeddable__ins-and-outs-single-value">
                        <div className="team-lineups-ins-and-outs__grid team-lineups-ins-and-outs__grid--home">
                            <div className="team-lineups-ins-and-outs__grid-item-wrapper">
                                <SkeletonLoader height={36} width={150} />
                            </div>
                            <div className="team-lineups-ins-and-outs__grid-item-wrapper">
                                <SkeletonLoader height={36} width={150} />
                            </div>
                            <div className="team-lineups-ins-and-outs__grid-item-wrapper">
                                <SkeletonLoader height={36} width={150} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div className="u-hide-from-tablet">
            <div className="team-lineups-condensed-embeddable--skeleton team-lineups-condensed-embeddable__ins-and-outs">
                <div className="team-lineups-condensed-embeddable__ins-and-outs-single">
                    <div className="team-lineups-condensed-embeddable__ins-and-outs-single-label">
                        <div className="team-lineups-ins-and-outs__title-wrapper">
                            <SkeletonLoader
                                className="team-lineups-condensed-embeddable team-lineups-ins-and-outs__title"
                                width={43}
                                height={16}
                            />
                        </div>
                    </div>
                    <div className="team-lineups-condensed-embeddable__ins-and-outs-single-value">
                        <div className="team-lineups-ins-and-outs__grid">
                            <div className="team-lineups-ins-and-outs__grid-item-wrapper">
                                <SkeletonLoader height={32} width={120} />
                            </div>
                            <div className="team-lineups-ins-and-outs__grid-item-wrapper">
                                <SkeletonLoader height={32} width={120} />
                            </div>
                            <div className="team-lineups-ins-and-outs__grid-item-wrapper">
                                <SkeletonLoader height={32} width={120} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </>
);
